import React from 'react'

import { Subscription, SubscriptionProps } from '../subscription/subscription.js'

export type SubscriptionCardProps = SubscriptionProps

export const SubscriptionCard = (props: SubscriptionCardProps): JSX.Element => {
    return (
        <div className="subscription-card">
            <Subscription {...props} />
        </div>
    )
}
